// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type Subscription,
  SubscriptionFromJSON,
  SubscriptionToJSON,
} from "../models/Subscription";
import {
  type SubscriptionsUpdate,
  SubscriptionsUpdateFromJSON,
  SubscriptionsUpdateToJSON,
} from "../models/SubscriptionsUpdate";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface NotificationSubscriptionsListRequest {
  /**
   *
   */
  tenantId: string;
}

export interface NotificationsSubscriptionsUpdateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  subscriptionsUpdate: SubscriptionsUpdate;
}

/**
 *
 */
export class NotificationsApi extends runtime.BaseAPI {
  /**
   * Creates request options for notificationSubscriptionsList without sending the request
   */
  async notificationSubscriptionsListRequestOpts(
    requestParameters: NotificationSubscriptionsListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling notificationSubscriptionsList().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/notifications/subscriptions`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return a paged list of notifications types the user is subscribed to.
   * List notification type subscriptions
   */
  async notificationSubscriptionsListRaw(
    requestParameters: NotificationSubscriptionsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<Subscription>>> {
    const requestOptions = await this.notificationSubscriptionsListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(SubscriptionFromJSON)
    );
  }

  /**
   * Return a paged list of notifications types the user is subscribed to.
   * List notification type subscriptions
   */
  async notificationSubscriptionsList(
    requestParameters: NotificationSubscriptionsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<Subscription>> {
    const response = await this.notificationSubscriptionsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for notificationsSubscriptionsUpdate without sending the request
   */
  async notificationsSubscriptionsUpdateRequestOpts(
    requestParameters: NotificationsSubscriptionsUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling notificationsSubscriptionsUpdate().'
      );
    }

    if (requestParameters["subscriptionsUpdate"] == null) {
      throw new runtime.RequiredError(
        "subscriptionsUpdate",
        'Required parameter "subscriptionsUpdate" was null or undefined when calling notificationsSubscriptionsUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/notifications/subscriptions`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SubscriptionsUpdateToJSON(requestParameters["subscriptionsUpdate"]),
    };
  }

  /**
   * Update the list of notification types the user is subscribed to.
   * Update notification type subscriptions
   */
  async notificationsSubscriptionsUpdateRaw(
    requestParameters: NotificationsSubscriptionsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<Subscription>>> {
    const requestOptions = await this.notificationsSubscriptionsUpdateRequestOpts(
      requestParameters
    );
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(SubscriptionFromJSON)
    );
  }

  /**
   * Update the list of notification types the user is subscribed to.
   * Update notification type subscriptions
   */
  async notificationsSubscriptionsUpdate(
    requestParameters: NotificationsSubscriptionsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<Subscription>> {
    const response = await this.notificationsSubscriptionsUpdateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }
}
